<template>
  <section class="custom-container">
    <h1>自定义采集</h1>
    <el-tabs v-model="activeTab">
      <template v-for="(item, index) in tabs">
        <el-tab-pane :key="index" :label="item.label" :name="item.name">
          <component :is="item.component" @click="handleClick"></component>
        </el-tab-pane>
      </template>
    </el-tabs>
  </section>
</template>
<script>
import CustomBaseInfo from './CustomBaseInfo'
import CustomConfig from './CustomConfig'

export default {
  name: 'interactCollectCreateCustom',
  components: {
    CustomBaseInfo,
    CustomConfig
  },
  data () {
    return {
      activeTab: 'baseInfo',
      tabs: [
        {
          name: 'baseInfo',
          label: '基本信息',
          component: 'CustomBaseInfo'
        },
        {
          name: 'collectConfig',
          label: '采集配置',
          component: 'CustomConfig'
        }
      ]
    }
  },
  methods: {
    handleClick (type) {
      if (type === 'next') {
        this.activeTab = 'collectConfig'
      }
    }
  }
}
</script>
<style lang="scss">

</style>
